import {Component, effect, inject} from '@angular/core';
import {idleCountdown, idleModalVisible} from '../../signals/idle.signal';
import {Dialog} from 'primeng/dialog';
import {Button, ButtonModule} from 'primeng/button';
import {AuthService} from '../../../core/auth/auth-service';
import {Router} from '@angular/router';
import {IdleService} from '../../services/idle.service';

@Component({
  selector: 'app-idle-modal',
  imports: [
    Dialog,
    ButtonModule,
    Button
  ],
  templateUrl: './idle-modal.html',
  styleUrl: './idle-modal.scss',
  standalone: true
})
export class IdleModal {
  private auth = inject(AuthService);
  private router = inject(Router);
  private idleService = inject(IdleService);
  visible = idleModalVisible;
  countdown = idleCountdown;

  interval: ReturnType<typeof setInterval> | undefined;

  constructor(){

    effect(()=>{

      if(this.visible()){
        clearInterval(this.interval);
        this.countdown.set(10);

        this.interval = setInterval(()=>{

          this.countdown.update(v => v - 1);

          if(this.countdown() === 0){
            this.logout();
          }

        },1000);

      }
      // Limpiar el interval si no esta visible el modal
      // console.log(this.visible());
      if(!this.visible()){
        clearInterval(this.interval);
      }

    });

  }

  continueSession(){

    clearInterval(this.interval);

    this.visible.set(false);

  }

  logout(){
    this.auth.logout().subscribe({
      next: () => {
        console.log('Logout exitoso');
        // Inhabilitamos la configuracion temporal
        localStorage.setItem('configTemporal', 'false');
        // avisamos que se cerro sesion por inactividad
        localStorage.setItem('idle', 'true');
        // Deshabilitamos el servicio que observa los eventos
        clearInterval(this.interval);
        this.visible.set(false);
        this.idleService.stopWatching();
        console.log("logout");
        // enviamos al login con state true para evitar la confirmacion del guard
        this.router.navigate(['/login'], {
          state: {skipConfirm: true},
          replaceUrl: true
        });
      },
      error: err => console.error('Error en logout', err)
    });

  }
}
